import {FC, useCallback, useRef} from 'react'
import {ContactForm} from '../../../../../../services/cellcast.v2.types'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {QRCode} from 'react-qrcode-logo'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

export type QrCodeModalProps = {
  show: boolean
  contactForm?: ContactForm
  handleClose: () => void
}

const QrCodeModal: FC<QrCodeModalProps> = (props) => {
  const {contactForm, show, handleClose} = props
  const qrRef = useRef<QRCode>(null)

  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-700px h-auto'
      show={show}
      onHide={handleClose}
    >
      <div className='scroll-x'>
        <div className='modal-header'>
          <h2 className='fs-2'>QR Code {contactForm?.name ?` - ${contactForm?.name}` : ""}</h2>
          <div
            className='btn btn-icon btn-sm'
            onClick={() => {
              handleClose()
            }}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body py-lg-5 px-lg-5 border-bottom d-flex flex-column align-items-center mb-10'>
          <div className='mb-5 d-flex justify-content-center'>
            <QRCode
              ref={qrRef}
              size={400}
              value={`${ENV().REACT_APP_FE_URL}/contact-form/${contactForm?._id}`}
            />
          </div>
          <div className='d-flex gap-3'>
            <a
              href={`${ENV().REACT_APP_FE_URL}/contact-form/${contactForm?._id}`}
              target='_blank'
              rel='noopener noreferrer'
              className='btn btn-secondary'
            >
              Visit Form
            </a>
            <button
              className='btn btn-primary '
              onClick={() => {
                if (qrRef.current) {
                  qrRef.current?.download('png')
                }
              }}
            >
              Download QR Code
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default QrCodeModal
